import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=c4ff6df8&scoped=true&"
import script from "./ProductImages.vue?vue&type=script&lang=js&"
export * from "./ProductImages.vue?vue&type=script&lang=js&"
import style0 from "./ProductImages.vue?vue&type=style&index=0&id=c4ff6df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ff6df8",
  null
  
)

export default component.exports